
import Vue, { PropType } from 'vue';
import ImageThumbnail from './ImageThumbnail.vue';
import { CvRow, CvColumn } from '@carbon/vue';
import { SearchedArtwork } from '../typings';

export default Vue.extend({
  components: {
    ImageThumbnail,
    CvRow,
    CvColumn,
  },
  model: {
    prop: 'selectedItemId',
    event: 'update:selected-item-id',
  },
  props: {
    items: {
      type: [] as PropType<SearchedArtwork[]>,
      required: true,
    },
    selectedItemId: {
      type: String,
      default: '',
    },
  },
});
